<template>
  <div class="extended-search-block">
    <div>
      <h2>
        {{ header }}
      </h2>
    </div>
    <a-popover
        v-model:open="filtersPopoverOpen"
        trigger="click"
        placement="bottom"
        overlay-class-name="filters-popover"
    >
      <a-input v-model:value="currentFiltersLine" readonly placeholder="Поиск + фильтр" @click="openFilterModal">
        <template #suffix>
          <SearchOutlined style="color: rgba(0, 0, 0, 0.45)" />
        </template>
      </a-input>

      <template #content>
        <UserFilterForm v-if="type === 'staff'"
          :currentGroupId="currentGroupId"
          @close="() => {
            openFilterModal = false;
            filtersPopoverOpen = false;
          }"
        />
        <SmallUsersFilter v-else-if="type === 'order'"
            @close="() => {
            openFilterModal = false;
            filtersPopoverOpen = false;
          }"
        />
        <GroupFilterForm v-else
         @close="() => {
            openFilterModal = false;
            filtersPopoverOpen = false;
          }"
        />
      </template>

      <template #title>
        <span>Поиск + Фильтр</span>
      </template>
    </a-popover>
    <ReloadOutlined v-if="currentFiltersLine" @click="resetFilters" style="color: rgba(0, 0, 0, 0.45)" />
  </div>
</template>

<script>
import {ReloadOutlined, SearchOutlined} from "@ant-design/icons-vue";
import UserFilterForm from "@/feature/users/UserFilterForm.vue";
import GroupFilterForm from "@/feature/group-control/GroupFilterForm.vue";
import {ref} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import {useRoute} from "vue-router";
import SmallUsersFilter from "../../feature/users/SmallUsersFilter.vue";

export default {
  components: {SmallUsersFilter, GroupFilterForm, UserFilterForm, SearchOutlined, ReloadOutlined},
    props: {
      header: String,
      type: String,
    },
    setup(props) {
      const store = useStore();
      const route = useRoute();

      const currentFiltersLine = computed(() => props.type === 'group' ?
        store.state.group.filterString :
          store.state.users.filterString);

      const openFilterModal = ref(false);
      const filtersPopoverOpen = ref(false);

      const currentGroupId = computed(() => {
        if (route.name !== "group") return null;
        return route.params.id;
      });

      let resetFilters = () => {
        if (props.type === 'group') {
          store.dispatch('group/clearGroupFilters');
        } else {
          store.dispatch('users/clearUserFilters');
        }
      }

      return {
        currentFiltersLine,
        resetFilters,
        openFilterModal,
        filtersPopoverOpen,
        currentGroupId
      }
    }
  }
</script>

<style scoped lang="scss">
.extended-search-block h2 {
  font-size: 20px;
  font-weight: 600;
  line-height: 120%;
  margin-bottom: 0;
  min-width: max-content;
}

.extended-search-block {
  display: flex;
  align-items: center;
  column-gap: 10px;

  @media (max-width: $mobile-breakpoint) {
    display: none;
  }
}

@media (max-width: $mobile-breakpoint) {
  .extended-search-block {
    display: none;
  }
}
</style>